import { extend } from 'underscore';

const theme = {
  duration: '0.3s',
  ease: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  opacity: '.4',
};

// The default value of globalMenuHeight depends on
// the height of '.bingads-campaign-react-global-menu' element
const globalMenuHeight = document.getElementsByClassName('bingads-campaign-react-global-menu').length > 0 ? document.getElementsByClassName('bingads-campaign-react-global-menu')[0].clientHeight : 60;

const horizontalPanel = isLeft => ({
  width: '0%',
  height: '100%',
  '& .panel-content': extend({
    height: `calc(100% - ${globalMenuHeight}px)`,
    top: globalMenuHeight,
  }, isLeft ? {} : { right: '0' }),
  '& .panel-body': {
    height: '100%',
  },
  '&.isOpen': {
    width: '100%',
    '& .panel-content': {
      boxShadow: `${isLeft ? '' : '-'}2px 0 8px rgba(0, 0, 0, 0.15)`,
    },
  },
});

const verticalPanel = isTop => ({
  width: '100%',
  height: '0%',
  '& .panel-content': extend({
    width: '100%',
  }, isTop ? {} : { bottom: '0' }),
  '& .panel-body': {
    width: '100%',
  },
  '&.isOpen': {
    height: '100%',
    '& .panel-content': {
      boxShadow: `0 ${isTop ? '' : '-'}2px 8px rgba(0, 0, 0, .15)`,
    },
  },
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const getPanelStyles = ({ panel = {} }, { palette = { white: '#fff' } }) => {
  const {
    duration, ease, opacity,
  } = theme;
  return ({
    panelContainer: {
      position: 'fixed',
      top: 0,
      zIndex: 1000,
      '&:focus': {
        outline: 'none',
      },
      '& >*': {
        transition: `transform ${duration} ${ease}`,
      },
      '& .panel-mask': {
        backgroundColor: palette.white,
        opacity: '0',
        width: '0',
        height: '0',
        position: 'fixed',
        top: globalMenuHeight,
        transition: `opacity ${opacity} ${ease}, width 0s ease ${duration}, height 0s ease ${duration}`,
      },
      '& .panel-content': {
        position: 'fixed',
        background: palette.white,
        display: 'flex',
        flex: '0 0 auto',
        flexDirection: 'column',
      },
      '& .panel-body': {
        overflow: 'auto',
        position: 'relative',
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingBottom: '20px',
      },
      '& .panel-header': {
        paddingLeft: '16px',
        paddingRight: '56px',
        margin: '-34px 0px 14px 0px',
      },
      '& .panel-title': {
        fontWeight: '600',
        lineHeight: '27px',
        margin: '0px',
      },
      '& .panel-description': {
        fontSize: '14px',
        paddingLeft: '16px',
        paddingRight: '16px',
        marginBottom: '13px',
      },
      '& .panel-right': horizontalPanel(false),
      '& .panel-left': horizontalPanel(true),
      '& .panel-top': verticalPanel(true),
      '& .panel-bottom': verticalPanel(false),
      '& .panel-close-container': {
        display: 'flex',
        flex: '0 0 auto',
        justifyContent: 'flex-end',
      },
      '& .panel-cancel-icon': {
        top: 0,
      },
      '& .panel-close': {
        background: '#fff',
        padding: '0px 16px',
        height: '56px',
        minWidth: '44px',
        outline: 'none',
        border: 'none',
      },
      '& .panel-close:hover': {
        background: '#fff',
        outline: 'none',
        border: 'none',
      },
      '& .isOpen': {
        '& .panel-mask': {
          opacity,
          width: '100%',
          height: '100%',
          animation: `${duration} ${ease}`,
          transition: 'none',
        },
      },
    },
  });
};
